import Pluralize from "pluralize";
export var pluralize = function pluralize(str) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return !!count ? Pluralize(str, count) : Pluralize(str);
};
export var singularize = function singularize(str) {
  return Pluralize.singular(str);
};